import React, { FC } from "react";
import box from "../../assets/JoinNow/giftbox.svg";
import tinyGift from "../../assets/JoinNow/tinyGift.svg";
import { useTranslation } from "react-i18next";
export interface ICard {
  closepopup: () => void;
  countryname: string
}
export const Successpopup: FC<ICard> = ({ closepopup, countryname }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="fixed z-20 sm:top-[80px] inset-0 w-full h-full flex justify-center bg-black bg-opacity-50 pt-10 sm:pt-20 lg:pt-5">
        <div className="flex flex-col items-center justify-center bg-white rounded-3xl w-[90%] sm:w-[400px] lg:w-[450px] py-8 px-4 sticky top-[80px] h-fit sm:max-h-[80vh] overflow-y-auto mt-[60px] sm:mt-0">
          <div className="lg:w-auto md:w-24 w-24">
            <img src={box} alt="" />
          </div>
          <div className=" flex flex-col   font-poppins items-center lg:mt-3 md:mt-2">
            <span className="text-[#0B9308] font-medium lg:text-2xl md:text-xl">
              {t("joinow.component.Congratulations")}
            </span>
            <div className="flex lg:w-[20.50rem] lg:h-10 md:w-[18rem] md:h-8 w-[17rem] h-8 text-[#056E9C] bg-[#AED1E14F] rounded-3xl font-poppins font-normal  items-center justify-center gap-2 lg:text-sm md:text-xs text-xs lg:mt-4 md:mt-3 mt-3">
              <div className="lg:w-5 md:w-4 w-4">
                <img src={tinyGift} alt="gift" />
              </div>
              <span>{t("joinow.component.BONUS")}</span>
            </div>
            <div className="flex flex-col items-center justify-center font-poppins mt-8 ">
              <span className="lg:text-base md:text-xs text-xs text-[#056E9C]">
                {t("joinow.component.survey")}
              </span>
              <span className="mt-4 lg:text-base md:text-sm text-xs text-center">
                {t("joinow.component.range")} {countryname}!
              </span>
            </div>
            <button
              className="w-44 h-8 lg:w-56 lg:h-14 md:w-48 md:h-12 bg-[#056E9C] lg:text-base md:text-sm text-xs text-white rounded-3xl mt-12"
              onClick={closepopup}
            >
              {t("joinow.component.Earning")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
